import { CartItemInput, ItemTypes } from '@pizza-hut-us-development/client-core';
import DealType from '@/builders/deals/DealTypes';
import { parseCartItemToProduct, parseRecipeToBuiltPizza } from '@/cart/helpers/getUserRecipes';
import { AddableCartItemKinds } from '@/api/phdApiV2Client/request.types';
import { Deal, DealData } from '@/builders/deals/slice/dealTypes';
import { BuiltPizza } from '@/builders/pizza/dataTransformers/builderTypes';
import { CartItem } from '@/domain/cart/types';

export const transformCartItemInputToDeal = (item: CartItemInput, dealData: DealData): Deal => ({
  data: {
      kind: AddableCartItemKinds.DEAL,
      id: item.id,
      name: item.name || dealData.name,
      image: dealData.image ?? '',
      type: dealData.steps.length > 1 ? DealType.MULTI_STEP : DealType.SINGLE_STEP,
      steps: dealData.steps,
      rules: dealData.rules,
      quantity: item.quantity ?? 1,
      outOfStock: dealData.outOfStock ?? false,
      combinable: dealData.combinable,
      available: dealData.available ?? false
  },
  userSelections: 
    {
      past: [],
      present: {
        dealToDisplay: {
          id: item.id
        },
        currentStep: null,
        redeemingLoyaltyDeal: false,
        recipes: item.modifiers.map((modifier, idx) => {
          const product = modifier.modifiers[0]
          return {
            item: product.type === ItemTypes.PIZZA 
                                      ? parseRecipeToBuiltPizza(product.id, dealData.steps[idx].recipeOptions) as BuiltPizza
                                      : parseCartItemToProduct(modifier as CartItem),
            stepId: modifier.id,
            index: idx
          }
        })
    },
    future: []
  }
});